export default __webpack_public_path__ + "static/media/logo.b12de912.png";